import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Menu, MenuItem, Divider } from '@mui/material';
import { AddCircleOutline, FilterNone } from '@mui/icons-material';
import { Element, animateScroll } from 'react-scroll';
import styled from 'styled-components';
import { Navigate } from 'react-router';
import { getLogger } from 'loglevel';

import { socketURL } from './socket';
import Header from './Header';
import Editor from './Editor';
//import GenerateDocumentsDialog from './GenerateDocumentsDialog';
import { AppStates } from './FlowStore';

const log = getLogger('Review');
log.setLevel('info');

//const displayedWidth = 800; // was 700
//var blockScaler = originalPageWidth / displayedWidth;

//width: ${displayedWidth}px; //width: auto;
//const StyledImg = styled.img`
//  width: auto;
//  height: auto;
//`;

const StyledImg = styled.img`
  max-width: 100%;
  max-height: 100%;
  border: solid gray 1px;
`;

const RelativeDiv = styled.div` //styled.div
  position: relative;

`;

const GridDiv = styled.div`
  display: grid;
  grid-template-columns: 30% auto;
  flex: 1;
`;
//  grid-template-rows: 3% auto;

const PageNumberP = styled.p`
  grid-column: 2/3;
  grid-row: 1/2;
  align-self: end;
  justify-self: center;
`;

const HighlightedElement = styled(Element)`
  position: absolute;
  background-color: yellow;
  opacity: 0.4;
  top: ${props => props.block['t'] / props.page.height * 100}%;
  left: ${props => props.block['l'] / props.page.width * 100}%;
  width: ${props => props.block['w'] / props.page.width * 100}%;
  height: ${props => props.block['h'] / props.page.height * 100}%;
`;

const CurrentHighlightedElement = styled(Element)`
  position: absolute;
  background-color: yellow;
  border: 3px solid red;
  opacity: 0.4;
  top: ${props => props.block['t'] / props.page.height * 100}%;
  left: ${props => props.block['l'] / props.page.width * 100}%;
  width: ${props => props.block['w'] / props.page.width * 100}%;
  height: ${props => props.block['h'] / props.page.height * 100}%;
`;

const TabElement = styled.div`
  position: absolute;
  background-color: orange;
  opacity: 0.3;
  top: ${props => props.tabTop}px;
  left: ${props => props.tabLeft}px;
  width: 30px;
  height: 15px;
`;

const MiSpan = styled.span`
  padding-left: 5px;
`;


const MainContainerDiv = styled.div`
height: 100vh;
  display: flex;
  flex-direction: column;
`;

//  grid-column: 2/3;
//  grid-row: 2/3;
const DocumentContainerElement = styled(Element)`
  margin: 0;
  height: 90vh;
  overflow-y: scroll;
  position: relative;
  border-top: 1px solid gray;
  border-bottom: 1px solid gray;
`;
//  border: 5px solid ${Colors.GRAY5};

const BlockDiv = styled.div.attrs(props => ({
  style: {
    top: `${props.block['t'] / props.page.height * 100}%`,
    left: `${props.block['l'] / props.page.width * 100}%`,
    width: `${props.block['w'] / props.page.width * 100}%`,
    height: `${props.block['h'] / props.page.height * 100}%`,
  },
}))`
font-size: 1.3vw;
color: transparent; 
position: absolute;`;
// transparent;

// const BlockDivSvg = styled.text.attrs(props => ({
//   y: `${(props.block['t'] + props.block['h']/2) / props.page.height * 100}%`,
//   x: `${props.block['l'] / props.page.width * 100}%`,
//   textLength: `${props.block['w'] / props.page.width * 100}%`,
//   style: {
//     fontSize: '200%',
//   },
// }))`
// fill:red;
// position: absolute;`;
 

@observer
class Review extends Component {
  constructor(props) {
    super(props);
    this.store = this.props.store;
    this.target = null;
    this.state = {
      isOpen: false,
      mouseX: null,
      mouseY: null,
      index: null,
      image_num: null,
    };
  }

  componentDidMount() {
    //window.addEventListener("resize", this.handleResize);
  };
  componentWillUnmount() {
    //window.addEventListener("resize", null);
  };
  handleResize = () => {
    //this.setState({WindowSize: window.innerWidth})
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    //log.info('Review did update');
    if (this.store.currentIssue !== null && this.state.mouseY === null) {
      let store = this.store;
      this.scrollTo(store.rejections[store.currentIssue].page_num,
                    store.rejections[store.currentIssue].line_num);
    }
    if (this.store.errorIngestingFile) {
      this.props.resetError();
      this.showFailToaster();
    }
  }

  handleClose = (e) => {
    log.info('Handling close', this.target);
    this.target.style.border = 'none';
    this.setState({mouseX: null, mouseY: null});
    //this.setState({mouseX: null, mouseY: null, target: {style: {border: 'none'}}});
  }
  
  scrollTo(pageNum, lineNum) {
    let page_target = `page_${pageNum}`;
    let target=`${page_target}_${lineNum}`;
    // Without buggy scroller, we should just be able to do this
    //scroller.scrollTo(target, {duration: 800, containerId:'scroll-container', offset:-200, smooth: 'easeInOutQuart'});
    // Buf it need be, the best we may be able to do is get to the page
    // scroller.scrollTo(page_target, {duration: 800, smooth: 'easeInOutQuart', containerId:'scroll-container'});
    
    // we will calculate the offset ourselves.
    let page = document.getElementById(page_target);
    if (!page) return;
    let box = document.getElementsByName(target)[0];
    log.debug('Scrolling to ' + target + ' ' + page.offsetTop + ' ' + box.offsetTop);
    animateScroll.scrollTo(page.offsetTop+box.offsetTop-200,
                           {duration: 500, smooth: 'easeInOutQuart', containerId:'scroll-container'});
  }

  showFailToaster = () => {
    // UploadToaster.show({
    //   intent: Intent.DANGER,
    //   message:
    //     'We had difficulty processing your file.  Please try again with a different file, or wait a bit and try again.',
    //   onDismiss: () => this.navigateToDashboardScreen()
    // });
  };

  toggleDialog = failure => {
    log.debug('Toggling dialog ' + this.state.isOpen);
    const openState = this.state.isOpen;
    if (!this.state.isOpen)
      this.store.client = '';  // FIXME:  this is a bit garish, but we want to force them to select each time
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
    if (openState && failure) {
      //this.props.history.push('/refresh/review');
    }
  };

  displayImages = () => {
    return this.store.images.map((image, index) => {
      return (
        <RelativeDiv key={image.url} id={`page_${image.image_num}`} className="element">
          <StyledImg
            src={`${socketURL}${image.url}`}
            alt="Office Action Text"
          />
          {/*
          <svg style={{position: 'absolute', top: 0, left: 0,
                       viewBox: "0 0 100 100",
                       width: "100%", height: "100%",
                       border: 'solid 5px red'}}>
            {!!this.store.pages &&
             !!this.store.rejections &&
             this.generateBlocks(image.image_num)}
          </svg>
           */}
          {!!this.store.pages &&
           !!this.store.rejections &&
           this.generateBlocks(image.image_num)}
        </RelativeDiv>
      );
    });
  };

  generateTabs() {
    //log.info(this.store.rejections);
    //log.info(this.store.pages);
    if (!this.store.rejections || !this.store.pages)
      return null;
    if (this.store.pages.length < 1)
      return null;
    // Fix we should be able to do this without having to fetch scroll-container's
    // dimensions, but if we use % of container, the measurements are slightly off due
    // to the height of the scrollbar arrows at top and bottom...
    // So we are using absolute positioning...
    let container = document.getElementById('scroll-container');
    if (container === null) return null;
    
    // calculate the total document height
    let pageHeight = this.store.pages[0].height;
    let docHeight = this.store.pages.length * pageHeight;
    return this.store.rejections.map((rejection, index) => {
      let page = this.store.pages[rejection.page_num-1];
      let block = page.lines[rejection.line_num-1];
      let poffset = ((rejection.page_num-1) * pageHeight + block.t) / docHeight;
      return ( 
        <TabElement
          poffset={poffset}
          tabTop={poffset * (container.offsetHeight-30) + 15}
          tabLeft={container.offsetWidth - 30}
          name={`rej_${index + 1}`}
          key={`rej_${index + 1}`}
          onClick={()=>{
            this.store.setCurrentIssue(index);
          }}
        >
        </TabElement>
      );
    });
  }

  generateBlocks(image_num) {
    const page = this.store.pages[image_num - 1];
    if (page.lines) {
      return page.lines.map((block, index) => {
        // If we have rejections
        if (this.store.rejections.some(
          item => item.page_num === image_num && item.line_num === index + 1 )) {
          // If on current issue, highlight it as current
          if (
            this.store.currentIssue != null &&
              this.store.rejections[this.store.currentIssue].page_num ===
              image_num &&
              this.store.rejections[this.store.currentIssue].line_num ===
              index + 1 ) {
            return (
              <CurrentHighlightedElement
                className="element" 
                block={block}
                page={page}
                name={`page_${image_num}_${index + 1}`}
                key={`page_${image_num}_${index + 1}`}
              />
            );
          }
          else {  // otherwise just highlight the issue
            return (
              <HighlightedElement
                className="element" 
                block={block}
                page={page}
                name={`page_${image_num}_${index + 1}`}
                key={`page_${image_num}_${index + 1}`}
              />
            );
          }
        }
        // Not a rejection block
        else {
          return (
            <BlockDiv
              data-toggle="tooltip"
              title="Right click to add new issue/rejection here"
              block={block}
              page={page}
              key={`page_${image_num}_${index + 1}`}
              style={{cursor: 'context-menu'}}
              onContextMenu={(e) => {
                e.preventDefault();
                this.setState({
                  mouseX: e.clientX, mouseY: e.clientY,
                  block: block, index: index, image_num: image_num,
                  //target: e.target
                });
                this.target = e.target;
                e.target.style.border = '1px solid red';
              }}
            >
              {block.text}
            </BlockDiv>
          );
        }
      });
    }
    return null;
  }
                  //{ left: e.clientX, top: e.clientY },
  //() => {target.style.border = 'none'},

  generateCM() {
    //log.info('Generating CM', this.state.mouseX, this.state.mouseY, this.state.block);
    if (this.state.mouseY === null)
      return null;
    return (
      <Menu
        open={this.state.mouseY !== null}
        onClose={(e) => this.handleClose(e)}
        anchorReference="anchorPosition"
        anchorPosition={
          this.state.mouseY !== null && this.state.mouseX !== null
            ? { top: this.state.mouseY, left: this.state.mouseX }
          : undefined
        }
      >
        <MenuItem
          onClick={(e) => {
            log.debug(toJS(this.props.block));
            this.handleClose(e);
            this.store.addIssue(this.state.index + 1, this.state.image_num);
          }} >
          <AddCircleOutline />
          <MiSpan>Add Issue/Rejection</MiSpan>
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            // target.style.opacity = 0;
            // target.style.backgroundColor = 'none';
            this.handleClose(e);
            let txt = window.getSelection().toString();
            log.debug('S: ' + txt);
            navigator.clipboard.writeText(txt);
          }} >
          <FilterNone />
          <MiSpan>Copy Selected</MiSpan>
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            navigator.clipboard.writeText(this.state.block.text);
            this.handleClose(e);
          }} >
          <FilterNone />
          <MiSpan>Copy Entire Line</MiSpan>
        </MenuItem>
        <Divider />
        <MenuItem style={{fontWeight: 'bold'}}>
          <FilterNone />
          <MiSpan>Copy Word:</MiSpan>
        </MenuItem>
        {
          this.state.block.text.replace(/[^\-.a-zA-Z0-9 ]/g, '')
              .split(' ')
              .filter((word, i) => {
                return (word[0] > 'A' && word[0] < 'Z') || (word[0] > '0' && word[0] < '9');
              })
              .map((word, i) => {
                return (
                  <MenuItem
                    key={`page_${this.state.image_num}_${this.state.index + 1}_${i}`}
                    icon="duplicate" 
                    onClick={(e) => {
                      this.handleClose(e);
                      navigator.clipboard.writeText(word);
                    }}
                  >
                    <span style={{paddingLeft: 35}}>{word}</span>
                  </MenuItem>);
              })
        }
      </Menu>
    );
  }

  render() {
    if (this.store.appState === AppStates.DASHBOARD) {
      return <Navigate to="/dashboard" />;
    }
    if (this.store.appState === AppStates.GENDOCS) {
      return <Navigate to="/genDocs" />;
    }

    return (
      <MainContainerDiv>
        <Header store={this.store}/>
        <GridDiv>
          <PageNumberP>
            Total document length:{' '}
            {this.store.images &&
             this.store.images.length === this.store.numPages &&
             this.store.images.length}
            {` pages`}
          </PageNumberP> 
          <Editor store={this.store} />
          <div style={{gridColumn: '2/3', gridRow: '2/3', position: 'relative',
                       marginRight: '10px'}}>
            <DocumentContainerElement id="scroll-container">
                {this.store.images &&
                 this.store.images.length === this.store.numPages &&
                 this.displayImages()}
            </DocumentContainerElement>
            {this.generateCM()}
            {this.generateTabs()}
          </div>
          <div style={{gridColumn: '1/2', gridRow: '3/4'}}>
            {JSON.stringify(this.store.sessionInfo())}
          </div>
        </GridDiv>
      </MainContainerDiv>
    );
  }
}

// doc container used to be position:relative and height:88vh

export default Review;

